<template>
  <div class="home-landing">
    <img v-if="settings.landing_image" :src="settings.landing_image" />
    <CommonVideo v-if="landingVideo" :src="landingVideo" />
  </div>
</template>

<script>
import CommonVideo from '../common/CommonVideo.vue'

export default {
  components: { CommonVideo },

  props: {
    landingVideo: {
      type: String,
      default: '',
    },
    settings: {
      type: Object,
    },
  },
  mounted() {},
}
</script>

<style lang="scss">
@import '~/styles/base.scss';

.home-landing {
  position: relative;
  /* height: calc(100vh - var(--header-height)); */
  margin-bottom: 20px;
  height: calc(var(--1vh) * 100);

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
</style>
